import {RootState} from '../index';
import {InferenceApplicationInfo} from './../../types/deployment/InferenceApplicationsResponse';

export const getInferenceApplications = (
  state: RootState
): Array<InferenceApplicationInfo> => state.deploymentDashboard.inferenceApps.data;

export const getInferenceApplicationsCount = (state: RootState): number =>
  state.deploymentDashboard.inferenceApps.count;
